module.exports = __webpack_public_path__ + "images/48d610f2484e02b4060eeb75baa0aa09.jpg";